import type { Nullable } from 'corgi-types';

import type { FieldChangeTrigger } from '../../../enums/form';
import type { FieldChangeTriggerHandler } from '../../../types/form';
import type { IntlTelInputChangeResult } from '../../../types/tel';
import { formatTel } from '../../../utils/tel';

interface GetChangeHandlerOptions<FieldName extends string> {
  fieldName: FieldName;
  value: Nullable<IntlTelInputChangeResult>;
  trigger: FieldChangeTrigger;
  onChange: FieldChangeTriggerHandler<FieldName>;
}

const getFormattedValue = (value: Nullable<IntlTelInputChangeResult>) => {
  if (!value) {
    return '';
  }

  return formatTel(value);
};

export const getChangeHandler = <FieldName extends string>({
  fieldName,
  value,
  trigger,
  onChange,
}: GetChangeHandlerOptions<FieldName>) =>
  onChange({
    fieldName,
    value: getFormattedValue(value),
    trigger,
  });
